import type { ColorPalette } from '@/features/colors/color.types';
import {
  NEUTRAL_COOL,
  NEUTRAL_GRAY,
  NEUTRAL_WARM,
} from '@/features/colors/neutrals';

// Slots in design's column order: red, orange, yellow, tan, green, navy,
// purple, gray — note tan is color6, not color3, matching joyful. Shades by
// role: 500 primary accent, 300 muted, 100 light category, 50 shaded cell.
//
// Primary's sheet omits the warm/cool row that joyful's carries, so the tie is
// taken from joyful's convention for the same eight columns: the warm half
// (red, orange, yellow, tan) on the warm ramp, the cool half (green, navy,
// purple, gray) on the cool one.
export const primaryPalette: ColorPalette = {
  id: 'primary',
  name: 'Primary',
  description: 'True primary colors',
  requiresPaidPlan: true,
  colors: {
    cool: { ...NEUTRAL_COOL },
    gray: { ...NEUTRAL_GRAY },
    warm: { ...NEUTRAL_WARM },
    color0: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FCD7D7',
        '100': '#FBDEE2',
        '300': '#F0738A',
        '500': '#E4002B',
      },
    },
    color1: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEFE6',
        '100': '#FCEADB',
        '300': '#F3AC81',
        '500': '#E9681A',
      },
    },
    color2: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F9F4E1',
        '100': '#FDF6D6',
        '300': '#FFE773',
        '500': '#FFD400',
      },
    },
    color3: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#E9F8EB',
        '100': '#DEF1E1',
        '300': '#82CA97',
        '500': '#1B9E42',
      },
    },
    color4: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EBF4FF',
        '100': '#DCE2F1',
        '300': '#7393C8',
        '500': '#003A9B',
      },
    },
    color5: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F8EFFF',
        '100': '#EBDFF2',
        '300': '#AD82C7',
        '500': '#6A1B9A',
      },
    },
    color6: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FAF2EB',
        '100': '#EEE6DB',
        '300': '#C0A48A',
        '500': '#8D5A2B',
      },
    },
    color7: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        // Matches the wash rather than sitting under it: the old #BABABA read as
        // a blocked-out slab wherever a whole surface took it.
        '50': '#E2E2E2',
        '100': '#E2E2E2',
        '300': '#8A8A8A',
        '500': '#1A1A1A',
      },
    },
  },
};
